import { useState } from "react";
import Edit  from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import EditAppModal from "./EditAppModal";
import DeleteAppModal from "./DeleteAppModal";

const useStyles = makeStyles((theme) => ({
    card: {
      transition: 'transform 0.3s', 
      '&:hover': {
        transform: 'scale(1.1)',
        boxShadow: 'none',
      },
      cursor:"pointer"
    },
  }));

const SuperadminAppCard = ({ p, handleEditSubmit, loading }) => {
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [appName, setAppName] = useState(p.app_name);
    const [selectedValue, setSelectedValue] = useState("");
    const [imageString, setImageString] = useState("");

    const handleClickEdit = () => {
        setOpenEdit(!openEdit);
        setOpenDelete(false);
    };

    const handleDeleteSubmit = () => {};

    const handleDeleteChange = event => {
        setSelectedValue(event.target.value);
    };

    const handleClickDelete = () => {
        setOpenDelete(!openDelete);
        setOpenEdit(false);
    };

    const convertToBase64 = async file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setImageString(reader.result);
        };
        
    };

    const handleFileChange = async e => {
        let file = e.target.files[0];
        try {
            await convertToBase64(file);
        } catch (error) {
        }
    };

    const handleEditChange = e => {
        setAppName(e.target.value);
    };

    const handleEditSubmitClick = async id => {
        await handleEditSubmit(id, appName, imageString);
        setOpenEdit(false);
    };

    const classes = useStyles();

    return (
        <Card
            className={classes.card}
            sx={{ height: '100%',width: '90%'}}
        >
            <Box
                sx={{
                    width: "50%", 
                    height: "50%", 
                    borderRadius: "50%", // Make the box circular
                    backgroundColor: "#F8F9FF", 
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "12%", 
                    marginLeft: "25%", 
                    
                }}
            >
                <CardMedia
                    component="img"
                    image={p.app_image_url}
                    alt={p.app_name}
                    sx={{p:5,width:"100%"}} //p:5
                />
            </Box>
            
            <Box
                sx={{
                    p: 0.5,
                    textAlign: 'center',
                    backgroundColor: "white",
                    marginTop:"2%",
                }}
            >
                <Typography color="#333333" style={{fontSize: '1.5em',fontFamily:"Lato"}}>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Box sx={{display:"flex", alignItems:"center", margin:"5%"}}>
                            <Edit onClick={handleClickEdit} style={{ cursor: "pointer" }} />
                            <EditAppModal 
                                openEdit = {openEdit}
                                setOpenEdit = {setOpenEdit}
                                handleEditChange = {handleEditChange}
                                handleFileChange = {handleFileChange}
                                handleEditSubmitClick = {handleEditSubmitClick}
                                appId = {p.app_id}
                                appName = {appName}
                                loading = {loading}
                            />
                        </Box>

                        {p.app_name}

                        <Box sx={{display:"flex", alignItems:"center", margin:"5%"}}>
                            <Delete onClick={handleClickDelete} style={{ cursor: "pointer" }} />
                            <DeleteAppModal 
                                openDelete = {openDelete}
                                setOpenDelete = {setOpenDelete}
                                handleDeleteChange = {handleDeleteChange}
                                handleDeleteSubmit = {handleDeleteSubmit}
                                selectedValue = {selectedValue}
                            />  
                        </Box>
                    </Box>
                </Typography>
            </Box>
        </Card>
    );
};

export default SuperadminAppCard;
